var _defs, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLivingSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3247ce63-7c06-4098-92ca-1e1f54bb128d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,84v0v-72v0h72v0v72v0z"
  })))), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Gruppe 3336"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "bg"), /*#__PURE__*/React.createElement("path", {
    d: "M0,48c0,-26.50967 21.49033,-48 48,-48c26.50967,0 48,21.49033 48,48c0,26.50967 -21.49033,48 -48,48c-26.50967,0 -48,-21.49033 -48,-48z",
    fill: "#ffffff",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "icon--liegenschaft"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Gruppe 3307"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Rechteck 2518")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3247ce63-7c06-4098-92ca-1e1f54bb128d)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5848"), /*#__PURE__*/React.createElement("path", {
    d: "M35.345,51.667c0,8.913 -4.501,13.683 -10.076,13.683c-5.575,0 -10.076,-4.77 -10.076,-13.683c0,-7.274 6.678,-15.025 9.152,-17.648c0.507,-0.537 1.311,-0.537 1.818,0c2.475,2.623 9.182,10.404 9.182,17.648z",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3247ce63-7c06-4098-92ca-1e1f54bb128d)"
  }, /*#__PURE__*/React.createElement("title", null, "Linie 549"), /*#__PURE__*/React.createElement("path", {
    d: "M25.2991,45.7346v28.618",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3247ce63-7c06-4098-92ca-1e1f54bb128d)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5849"), /*#__PURE__*/React.createElement("path", {
    d: "M19.128,74.353v0l60.426,0.06c0.686,0 1.252,-0.567 1.252,-1.252v-34.73c0,-0.685 -0.566,-1.252 -1.252,-1.252h-15.263v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-3247ce63-7c06-4098-92ca-1e1f54bb128d)"
  }, /*#__PURE__*/React.createElement("title", null, "Pfad 5850"), /*#__PURE__*/React.createElement("path", {
    d: "M35.345,22.84c0,-0.686 0.567,-1.252 1.252,-1.252h26.442c0.686,0 1.252,0.566 1.252,1.252v51.572l-27.694,-0.077c-0.685,0 -1.252,-0.567 -1.252,-1.252zM46.703,27.639h-3.786c-0.566,0 -1.013,0.447 -1.013,1.014v4.322zM57.703,27.639h-3.786c-0.566,0 -1.013,0.447 -1.013,1.014v4.322zM46.524,38.103h-3.786c-0.566,0 -1.013,0.447 -1.013,1.013v4.323zM57.524,38.103h-3.786c-0.566,0 -1.013,0.447 -1.013,1.013v4.323zM46.524,48.566h-3.786c-0.566,0 -1.013,0.447 -1.013,1.014v4.322zM43.245,73.629v0v-10.604c0,-0.686 0.566,-1.252 1.252,-1.252h10.643c0.685,0 1.252,0.566 1.252,1.252v10.604v0M52.725,53.902v0v-4.322c0,-0.567 0.447,-1.014 1.013,-1.014h3.786v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#004a5a",
    strokeMiterlimit: 20,
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLivingSpace);
export default __webpack_public_path__ + "static/media/dashboard-living-space.d31c590565f097bfbce0f66bd7c14681.svg";
export { ForwardRef as ReactComponent };